type WechatMiniprogramIconProps = {
  size?: number;
  className?: string;
};

/** Official 微信小程序 glyph (no filled circle). Simple Icons has WeChat only. */
export function WechatMiniprogramIcon({ size = 28, className }: WechatMiniprogramIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <g transform="translate(12 12) scale(1.28) translate(-12 -12)">
        <path d="M17.165 7.265a3.437 3.437 0 0 0-3.104-.94l-.118.024A3.661 3.661 0 0 0 11 9.939v4.122a1.66 1.66 0 0 1-1.335 1.629l-.118.023a1.437 1.437 0 0 1-.815-2.743l.104-.042a1 1 0 1 0-.743-1.857l-.104.042c-2.291.917-2.899 3.877-1.154 5.622a3.437 3.437 0 0 0 3.104.94l.118-.024A3.661 3.661 0 0 0 13 14.061V9.94a1.66 1.66 0 0 1 1.335-1.629l.118-.023a1.437 1.437 0 0 1 .815 2.743l-.104.042a1 1 0 1 0 .743 1.857l.104-.042c2.291-.917 2.899-3.877 1.154-5.622Z" />
      </g>
    </svg>
  );
}
